/*
Dentist Edit Profile Form Component
================================================================================
*/

/*
Imports
------------------------------------------------------------
*/
// libs
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {
  Field,
  reduxForm
} from 'redux-form';

// app
import Input from 'components/Input';
import LabeledInput from 'components/LabeledInput';
import InputGroup from 'components/InputGroup';
// images deletion actions

// local
import styles from '../styles.module.css';
import validator from '../validator';

/*
Field Validators
------------------------------------------------------------
*/

/*
Edit Profile Form
================================================================================
*/

@reduxForm({
  form: 'out-of-network-tab2',
  enableReinitialize:true,
  validate: validator,
})
@CSSModules(styles, { allowMultiple: true })
export default class Tab2 extends React.Component {

  constructor (props) {
    super(props);
    this.submitRef = React.createRef();
  }

  /*
  Actions
  ------------------------------------------------------------
  */



  getInput(props) {
    return new Input(props);
  }

  getLabeledInput(props) {
    return new LabeledInput(props);
  }


  getInputGroup(props) {
    return new InputGroup(props);
  }

  handleFormSubmit=(values)=>{
    this.props.changeUCR(values)
  }

  handleKeyDown = (e) => {
    if(e.key == "Enter") {
      e.preventDefault();
      this.submitRef.current.click()
    }
  }
  /*
  Render
  ------------------------------------------------------------
  */
  render() {
    const {
        handleSubmit,
        submitting
      } = this.props;

    return (
      <form className="form-horizontal">
      <div className="container" styleName="tab2">
        <div styleName="introtext">
             <p>Great! Let’s look at your UCR. </p>
             <p>We’ll do the math – simply enter the UCR price for each service.</p>
        </div>

          <div styleName="calculations" className="row" onKeyDown={this.handleKeyDown.bind(this)}>
              <div styleName="ucr">
                <div className="col-sm-6 text-right">Cleaning</div>
                <Field type="number"
                    name="cleaning"
                    component={this.getInputGroup}
                    large-button--primary
                    leftAddon="$"
                    label=""
                    width={6}
                  />
              </div>
              <div styleName="ucr">
                <div className="col-sm-6 text-right">Exam</div>
                <Field type="number"
                    component={this.getInputGroup}
                    name="exam"
                    large-button--primary
                    leftAddon="$"
                    label=""
                    width={6}
                    />
              </div>
              <div styleName="ucr">
                <div className="col-sm-6 text-right">Annual X-ray</div>
                <Field type="number"
                  component={this.getInputGroup}
                  name="xray"
                  leftAddon="$"
                  label=""
                  width={6}

                  />
              </div>
              <div styleName="ucr">
                <div className="col-sm-6 text-right">Additional annual items (e.g. Fluoride) </div>
                <Field type="number"
                  component={this.getInputGroup}
                  name="additional"
                  leftAddon="$"
                  label="optional"
                  width={6}
                  />
              </div>
          </div>

          <div styleName="nextbutton" className="row">
                <a className="btn btn-primary" styleName="large-button--primary"  onClick={handleSubmit(this.handleFormSubmit)} ref={this.submitRef}>ENTER MY COSTS {">"}</a>
          </div>
    </div>
      </form>
    );
  }
}
